import type { ReactNode } from "react";
import { Button, Card, Flex, Text } from "@jsq/ds/core";
import { BackButtonWithinForm } from "~/pages/Compliance/CaseDetailsDrawer/Profiles/OwnersAndControllersCard/CreateOwnersAndControllersFullscreenTakeover/BackButtonWithinForm";
import * as styles from "./styles_vanilla.css";

interface Props {
  title: string;
  subtitle?: string;
  backLabel?: string;
  onBack?: () => void;
  onEdit?: () => void;
  children: ReactNode;
}

export const SummaryCard = ({
  title,
  subtitle,
  backLabel,
  onBack,
  onEdit,
  children,
}: Props) => (
  <Card variant="white" isFullWidth>
    {backLabel && onBack && <BackButtonWithinForm onClick={onBack} displayText={backLabel} />}
    <Flex justifyContent="space-between" alignItems="flex-start" className={styles.titleRow}>
      <div>
        <Text variant="h3">{title}</Text>
        {subtitle && <Text variant="secondary-sm">{subtitle}</Text>}
      </div>
      {onEdit && (
        <Button variant="link" displayAsLink isInline onClick={onEdit}>
          Edit
        </Button>
      )}
    </Flex>
    {children}
  </Card>
);
